<template lang="html">
  <div class="homepage layout-page" :style="stylechat">
    <MenuLayout/>
    <v-layout row wrap justify-center align-center class="mt-3 pr-5 pl-5" @click="InputFocusCancel">
      <!-- <span class="tab-title">{{$t('LeftSide.header.homepage')}}</span> -->
      <v-avatar
        size="35"
        v-if="showTitle"
      >
      <v-img v-if="data_user.profilepicture" :src="data_user.profilepicture" alt="" class="img-position"></v-img>
      <v-img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`" alt="" class="img-position"></v-img>
      </v-avatar>
      <v-layout row class="pl-3" v-if="showTitle">
        <span class="tab-title-header text-overflow-header pl-5">{{data_user.name}}</span>
        <v-spacer></v-spacer>
        <v-img v-if="login_page === 'true'" @click="switchAccount()" :src="`${publicPath}/assets/img/homepage/icons_switch_account.png`" max-width="20" height="20" class="ma-2 mr-7 mt-5 " style="cursor: pointer;"/>
      </v-layout>
      <v-spacer v-if="!showTitle"></v-spacer>
      <v-col
        cols="1"
        justify="center"
        :align="item.path === '/creategroup' ? 'center' : 'end'"
        class="pa-0"
        v-for="(item, index) in list_menu"
        :key="item.path"
        >
        <v-btn
          class="color-btn"
          icon
          small
          @click="routePage(item.path)"
        >
          <v-icon class="fz-28">
            {{item.icon}}
          </v-icon>
        </v-btn>
      </v-col>
      <v-col
          cols="1"
          justify="start"
          align="end"
          class="pa-0 mr-3"
          v-if="login_page === 'true'"
        >
        <v-btn
          class="color-btn"
          icon
          small
          @click="routePage('/login')"
        >
          <v-icon class="fz-18">fa-solid fa-right-from-bracket</v-icon>
        </v-btn>
        </v-col>
    </v-layout>
    <!-- <v-divider class="mt-4 mb-2"></v-divider> -->
    <v-layout v-if="!showTitle" row wrap justify-start align-start class="pt-5 pl-5 pr-5 pb-2">
      <v-avatar
        size="60"
        @click="routePage('/profile')"
        style="cursor: pointer;"
      >
      <v-img v-if="data_user.profilepicture" :src="data_user.profilepicture" alt="" class="img-position"></v-img>
      <v-img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`" alt="" class="img-position"></v-img>
      </v-avatar>
      <v-layout @click="routePage('/profile')" column class="pl-3" style="cursor: pointer;">
        <span class="tab-title text-overflow">{{data_user.name}}</span>
        <span class="tab-title-status text-overflow">{{data_user.status}}</span>
      </v-layout>
      <v-spacer></v-spacer>
      <v-img v-if="login_page === 'true'" @click="switchAccount()" :src="`${publicPath}/assets/img/homepage/icons_switch_account.png`" max-width="30" height="30" class="ma-2 mr-7 mt-5 " style="cursor: pointer;"/>
    </v-layout>
    <!-- <v-layout row wrap justify-start align-center class="pt-2 pl-5 pr-5 pb-5" v-if="!hideTextField">
      <v-text-field
        ref="search"
        v-model="search"
        :placeholder="$t('LeftSide.searching')"
        prepend-inner-icon="mdi-magnify"
        solo
        dense
        hide-details
        clearable
        @focus="InputFocus($event)"
      ></v-text-field>
      <span v-if="!showTextField" class="pl-2 font-color-btn" @click="ClearSearch()">{{$t('AnswerQuestion.cancel')}}</span>
    </v-layout> -->
    <!-- <v-layout row wrap justify-start align-center class="pt-2 pl-5 pr-5 pb-5" @click="InputFocusCancel">
      <v-col
        :cols="item.path == '/creategroup' && $i18n.locale !== 'th' ? 4 : 3"
        justify="center"
        align="center"
        class="pa-0"
        v-for="(item, index) in list_menu"
        :key="item.path"
        >
        <v-btn
          class="color-btn"
          fab
          @click="routePage(item.path)"
        >
          <v-icon>
            {{item.icon}}
          </v-icon>
        </v-btn>
        <br>
        <span class="font-color-btn">{{item.text}}</span>
      </v-col>
    </v-layout>
    <v-divider class="mt-4 mb-2"></v-divider> -->
    <v-layout row wrap justify-start align-start class="pt-3 pl-5 pr-5 pb-2">
      <a-tabs style="width: 100%;">
        <a-tab-pane key="1" :tab="$t('LeftSide.header.friend')" style="width: 100%;">
            <v-layout v-if="listfriend.length !== 0" row wrap justify-start align-center class="pt-2 pl-5 pr-5 pb-1">
              <v-text-field
                ref="search"
                v-model="searchFriend"
                :placeholder="$t('Dialog.group.searching')"
                prepend-inner-icon="mdi-magnify"
                solo
                dense
                hide-details
                clearable
                @focus="InputFocus($event)"
              ></v-text-field>
              <span v-if="!showTextField" class="pl-2 font-color-btn" @click="ClearSearch()">{{$t('AnswerQuestion.cancel')}}</span>
            </v-layout>
            <div class="layout-panels mt-2" id="myscroll" v-on:scroll="scrollFunction">
              <v-list flat two-line v-if="listfriend.length !== 0">
                <v-subheader>
                  <b>{{$t('LeftSide.header.friend')}} {{FilterListfriend.length}}</b>
                </v-subheader>
                <v-list-item-group>
                  <template v-for="(item, index) in FilterListfriend">
                    <v-list-item
                      :key="item.tokenuser"
                      @click="openDialog('friend', item)"
                    >
                      <v-list-item-avatar>
                        <v-img v-if="item.profilepicture" :src="item.profilepicture" class="img-position"></v-img>
                        <v-img v-else-if="item.type === 'user'" :src="`${publicPath}/assets/img/default_profile/man-white.png`" alt="" class="img-position"></v-img>
                        <v-img v-else-if="item.type === 'bot'" :src="`${publicPath}/assets/img/default_profile/bot-white.png`" alt="" class="img-position"></v-img>
                        <v-img v-else-if="item.type === 'business'" :src="`${publicPath}/assets/img/default_profile/business-white.png`" alt="" class="img-position"></v-img>
                        <v-img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`" alt="" class="img-position"></v-img>
                      </v-list-item-avatar>
                      <v-list-item-content class="pt-0">
                        <v-list-item-title v-text="item.name" class="text-overflow pt-2"></v-list-item-title>
                        <v-list-item-subtitle v-text="item.status" class="tab-title-status text-overflow"></v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-icon v-if="item.type === 'bot'" class="icon-color">fas fa-robot</v-icon>
                      </v-list-item-action>
                    </v-list-item>
                    <v-divider
                      v-if="index < FilterListfriend.length - 1"
                      :key="index"
                    ></v-divider>
                  </template>
                </v-list-item-group>
              </v-list>
              <v-row v-else class="justify-center align-center mt-5">
                <v-btn
                  class="color-btn"
                  medium
                  text
                  outlined
                  @click="routePage('/addfriend')"
                >
                  <v-icon class="fz-28">
                    mdi-account-search
                  </v-icon>
                  {{$t('AnswerQuestion.addFriend')}}
                </v-btn>
                <!-- <br>
                <span class="font-color-btn">{{$t('AnswerQuestion.addFriend')}}</span> -->
              </v-row>
            </div>
          </a-tab-pane>

          <a-tab-pane key="2" :tab="$t('LeftSide.friend.group')" style="width: 100%;" v-if="listgroup.length !== 0">
            <v-layout row wrap justify-start align-center class="pt-2 pl-5 pr-5 pb-1">
              <v-text-field
                ref="search"
                v-model="searchGroup"
                :placeholder="$t('Dialog.forward.searchgroup')"
                prepend-inner-icon="mdi-magnify"
                solo
                dense
                hide-details
                clearable
                @focus="InputFocus($event)"
              ></v-text-field>
              <span v-if="!showTextField" class="pl-2 font-color-btn" @click="ClearSearch()">{{$t('AnswerQuestion.cancel')}}</span>
            </v-layout>
            <div class="layout-panels-group mt-2" id="myscrollGroup" v-on:scroll="scrollFunctionGroup">
              <v-list flat two-line>
                <v-subheader>
                  <b>{{$t('LeftSide.friend.group')}} {{FilterListgroup.length}}</b>
                </v-subheader>
                <v-list-item-group>
                  <template v-for="(item, index) in FilterListgroup">
                    <v-list-item
                      :key="item.group_id"
                      @click="openDialog('group', item)"
                    >
                      <v-list-item-avatar>
                        <v-img v-if="item.picture" :src="item.picture" class="img-position"></v-img>
                        <img v-else :src="`${publicPath}/assets/img/default_profile/group-white.png`" alt="" class="img-position">
                      </v-list-item-avatar>
                      <v-list-item-content class="pt-0">
                        <v-list-item-title v-text="item.name" class="text-overflow pt-2"></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider
                      v-if="index < FilterListgroup.length - 1"
                      :key="index"
                    ></v-divider>
                  </template>
                </v-list-item-group>
              </v-list>
            </div>
          </a-tab-pane>
          <a-tab-pane key="3" :tab="$t('LeftSide.friend.groupInvite')" style="width: 100%;" v-if="listgroup_invite.length !== 0">
            <!-- <v-layout row wrap justify-start align-center class="pt-2 pl-5 pr-5 pb-1">
              <v-text-field
                ref="search"
                v-model="searchGroup"
                :placeholder="$t('Dialog.forward.searchgroup')"
                prepend-inner-icon="mdi-magnify"
                solo
                dense
                hide-details
                clearable
                @focus="InputFocus($event)"
              ></v-text-field>
              <span v-if="!showTextField" class="pl-2 font-color-btn" @click="ClearSearch()">{{$t('AnswerQuestion.cancel')}}</span>
            </v-layout> -->
            <div class="layout-panels-group" id="myscrollGroup" v-on:scroll="scrollFunctionGroup">
              <v-list flat two-line class="pt-0">
                <v-subheader>
                  <b>{{$t('LeftSide.friend.groupInvite')}} {{listgroup_invite.length}}</b>
                </v-subheader>
                  <template v-for="(item, index) in listgroup_invite">
                    <v-list-item
                      :key="item.group_id"
                    >
                      <v-list-item-avatar @click="openDialog('group', item)">
                        <v-img v-if="item.picture" :src="item.picture" class="img-position"></v-img>
                        <v-img v-else :src="`${publicPath}/assets/img/default_profile/group-white.png`" alt="" class="img-position"></v-img>
                      </v-list-item-avatar>
                      <v-list-item-content class="pt-0" @click="openDialog('group', item)">
                        <v-list-item-title v-text="item.name" class="text-overflow pt-2"></v-list-item-title>
                        <v-list-item-subtitle class="tab-title-status text-overflow">
                          {{$t('LeftSide.friend.haveMember', {count: lengthactive(item.member, 'statemember')})}}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-layout row wrap>
                          <v-btn class="btn-confirm mr-2" small @click="acceptGroup(item, index)">{{$t('AnswerQuestion.joinGroup')}}</v-btn>
                          <v-icon @click="cancelGroup(item, index,)">mdi-close</v-icon>
                        </v-layout>
                      </v-list-item-action>
                    </v-list-item>
                    <v-divider
                      v-if="index < listgroup_invite.length - 1"
                      :key="index"
                    ></v-divider>
                  </template>
              </v-list>
            </div>
          </a-tab-pane>
      </a-tabs>
    </v-layout>
    <!-- <v-layout row wrap justify-start align-start class="pt-2 pl-5 pr-5 pb-5" @click="InputFocusCancel">
      <div
        class="layout-panels mt-5"
        v-if="checkList()"
      >
        <span class="tab-title ma-5">{{$t('LeftSide.addFiend.detailSearch')}}</span>
      </div>

      <div class="layout-panels" v-else id="myscroll" v-on:scroll="scrollFunction">
        <v-expansion-panels>

          <v-expansion-panel v-if="listfriend_send_invite.length !== 0">
            <v-expansion-panel-header>
              {{$t('LeftSide.friend.sendFriendInvite')}} ({{listfriend_send_invite.length}})
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-list flat two-line>
                  <template v-for="(item, index) in listfriend_send_invite">
                    <v-list-item
                      :key="item.tokenuser"
                    >
                      <v-list-item-avatar @click="openDialog('send_sequest_friend', item)">
                        <v-img v-if="item.profilepicture" :src="item.profilepicture" class="img-position"></v-img>
                        <v-img v-else-if="item.type === 'user'" :src="`${publicPath}/assets/img/default_profile/man-white.png`" alt="" class="img-position"></v-img>
                        <v-img v-else-if="item.type === 'bot'" :src="`${publicPath}/assets/img/default_profile/bot-white.png`" alt="" class="img-position"></v-img>
                        <v-img v-else-if="item.type === 'business'" :src="`${publicPath}/assets/img/default_profile/business-white.png`" alt="" class="img-position"></v-img>
                        <v-img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`" alt="" class="img-position"></v-img>
                      </v-list-item-avatar>
                      <v-list-item-content class="pt-0" @click="openDialog('send_sequest_friend', item)">
                        <v-list-item-title v-text="item.name" class="text-overflow pt-2"></v-list-item-title>
                        <v-list-item-subtitle class="tab-title-status text-overflow">{{$t('LeftSide.friend.waitingRequestFriend')}}</v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-btn class="btn-cancel" text @click="cancelSendInvite(item, index, 'send_request')">{{$t('AnswerQuestion.cancel')}}</v-btn>
                      </v-list-item-action>
                    </v-list-item>
                    <v-divider
                      v-if="index < listfriend_send_invite.length - 1"
                      :key="index"
                    ></v-divider>
                  </template>
              </v-list>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel v-if="listfriend_invite.length !== 0">
            <v-expansion-panel-header>
              {{$t('LeftSide.friend.friendInvite')}} ({{listfriend_invite.length}})
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-list flat two-line>
                  <template v-for="(item, index) in listfriend_invite">
                    <v-list-item
                      :key="item._id"
                    >
                      <v-list-item-avatar @click="openDialog('request', item)">
                        <v-img v-if="item.profilepicture" :src="item.profilepicture" class="img-position"></v-img>
                        <v-img v-else-if="item.type === 'user'" :src="`${publicPath}/assets/img/default_profile/man-white.png`" alt="" class="img-position"></v-img>
                        <v-img v-else-if="item.type === 'bot'" :src="`${publicPath}/assets/img/default_profile/bot-white.png`" alt="" class="img-position"></v-img>
                        <v-img v-else-if="item.type === 'business'" :src="`${publicPath}/assets/img/default_profile/business-white.png`" alt="" class="img-position"></v-img>
                        <v-img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`" alt="" class="img-position"></v-img>
                      </v-list-item-avatar>
                      <v-list-item-content class="mr-3 pt-0" @click="openDialog('request', item)">
                        <v-list-item-title v-text="item.name" class="text-overflow pt-2"></v-list-item-title>
                        <v-list-item-subtitle v-text="item.status" class="tab-title-status text-overflow"></v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-layout row wrap>
                          <v-btn class="btn-confirm mr-2" small @click="acceptRequest(item, index)">{{$t('AnswerQuestion.acceptFriend')}}</v-btn>
                          <v-icon @click="cancelSendInvite(item, index, 'request')">mdi-close</v-icon>
                        </v-layout>
                      </v-list-item-action>
                    </v-list-item>
                    <v-divider
                      v-if="index < listfriend_invite.length - 1"
                      :key="index"
                    ></v-divider>
                  </template>
              </v-list>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel v-if="listgroup_invite.length !== 0">
            <v-expansion-panel-header>
              {{$t('LeftSide.friend.groupInvite')}} ({{listgroup_invite.length}})
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-list flat two-line>
                  <template v-for="(item, index) in listgroup_invite">
                    <v-list-item
                      :key="item.group_id"
                    >
                      <v-list-item-avatar @click="openDialog('group', item)">
                        <v-img v-if="item.picture" :src="item.picture" class="img-position"></v-img>
                        <v-img v-else :src="`${publicPath}/assets/img/default_profile/group-white.png`" alt="" class="img-position"></v-img>
                      </v-list-item-avatar>
                      <v-list-item-content class="pt-0" @click="openDialog('group', item)">
                        <v-list-item-title v-text="item.name" class="text-overflow pt-2"></v-list-item-title>
                        <v-list-item-subtitle class="tab-title-status text-overflow">
                          {{$t('LeftSide.friend.haveMember', {count: lengthactive(item.member, 'statemember')})}}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-layout row wrap>
                          <v-btn class="btn-confirm mr-2" small @click="acceptGroup(item, index)">{{$t('AnswerQuestion.joinGroup')}}</v-btn>
                          <v-icon @click="cancelGroup(item, index,)">mdi-close</v-icon>
                        </v-layout>
                      </v-list-item-action>
                    </v-list-item>
                    <v-divider
                      v-if="index < listgroup_invite.length - 1"
                      :key="index"
                    ></v-divider>
                  </template>
              </v-list>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel v-if="FilterListgroup.length !== 0">
            <v-expansion-panel-header>
              {{$t('LeftSide.friend.group')}} ({{FilterListgroup.length}})
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-list flat two-line>
                <v-list-item-group>
                  <template v-for="(item, index) in FilterListgroup">
                    <v-list-item
                      :key="item.group_id"
                      @click="openDialog('group', item)"
                    >
                      <v-list-item-avatar>
                        <v-img v-if="item.picture" :src="item.picture" class="img-position"></v-img>
                        <img v-else :src="`${publicPath}/assets/img/default_profile/group-white.png`" alt="" class="img-position">
                      </v-list-item-avatar>
                      <v-list-item-content class="pt-0">
                        <v-list-item-title v-text="item.name" class="text-overflow pt-2"></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider
                      v-if="index < FilterListgroup.length - 1"
                      :key="index"
                    ></v-divider>
                  </template>
                </v-list-item-group>
              </v-list>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel v-if="FilterListfriend.length !== 0">
            <v-expansion-panel-header>
              {{$t('LeftSide.header.friend')}} ({{FilterListfriend.length}})
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-list flat two-line>
                <v-list-item-group>
                  <template v-for="(item, index) in FilterListfriend">
                    <v-list-item
                      :key="item.tokenuser"
                      @click="openDialog('friend', item)"
                    >
                      <v-list-item-avatar>
                        <v-img v-if="item.profilepicture" :src="item.profilepicture" class="img-position"></v-img>
                        <v-img v-else-if="item.type === 'user'" :src="`${publicPath}/assets/img/default_profile/man-white.png`" alt="" class="img-position"></v-img>
                        <v-img v-else-if="item.type === 'bot'" :src="`${publicPath}/assets/img/default_profile/bot-white.png`" alt="" class="img-position"></v-img>
                        <v-img v-else-if="item.type === 'business'" :src="`${publicPath}/assets/img/default_profile/business-white.png`" alt="" class="img-position"></v-img>
                        <v-img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`" alt="" class="img-position"></v-img>
                      </v-list-item-avatar>
                      <v-list-item-content class="pt-0">
                        <v-list-item-title v-text="item.name" class="text-overflow pt-2"></v-list-item-title>
                        <v-list-item-subtitle v-text="item.status" class="tab-title-status text-overflow"></v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-icon v-if="item.type === 'bot'" class="icon-color">fas fa-robot</v-icon>
                      </v-list-item-action>
                    </v-list-item>
                    <v-divider
                      v-if="index < FilterListfriend.length - 1"
                      :key="index"
                    ></v-divider>
                  </template>
                </v-list-item-group>
              </v-list>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
    </v-layout> -->
    <DetailFriendDialog :DetailFriendDialog="DetailFriendDialog" :InforFriend="InforFriend" @closeDialog="closeDialog" />
    <DetailGroupDialog :DetailGroupDialog="DetailGroupDialog" :InforGroup="InforGroup" @closeDialog="closeDialog" />
    <ErrorDialog :ErrorDialog="ErrorDialog" :ErrorDialogDetail="ErrorDialogDetail" @closeAlertDialog="closeAlertDialog"/>
    <WarningDialog :WarningDialog="WarningDialog" :WarningDialogDetail="WarningDialogDetail" @emitWarning="emitWarning" @closeAlertDialog="closeAlertDialog"/>
    <ListBusiness :persistent="persistent" :ListBusinessData="ListBusinessData" :ListBusinessDialog="ListBusinessDialog" @closeDialog="closeDialog" />
  </div>
</template>

<script>
import {
  sync
} from 'vuex-pathify'
import DetailFriendDialog from '@/components/DetailFriend'
import DetailGroupDialog from '@/components/DetailGroup'
import ErrorDialog from '@/components/Alert/Error'
import WarningDialog from '@/components/Alert/Warning'
import MenuLayout from '@/views/MenuLayout'
import ListBusiness from '@/views/ListBusiness'

export default {
  data() {
    return {
      searchFriend: '',
      searchGroup: '',
      showTitle: false,
      publicPath: process.env.VUE_APP_BASE_PATH,
      WarningDialog: false,
      WarningDialogDetail: {},
      ErrorDialogDetail: {},
      ErrorDialog: false,
      DetailFriendDialog: false,
      DetailGroupDialog: false,
      InforFriend: {},
      InforGroup: {},
      showTextField: true,
      hideTextField: false,
      search: '',
      stylechat: {
        "--Homepage-HeaderColor": "white",
        "--Homepage-TabBackground": "white",
        "--Homepage-Icon": "gray",
        "--Homepage-IconActive": "#2662ae",
        "--Homepage-Background": "white",
        "--Homepage-FontSize": "18px",
        "--Homepage-FontColor": "black",
        "--Homepage-FontSize-Status": "14px",
        "--Homepage-FontColor-Status": "grey",
        "--Homepage-Background-Input": "#E2E1E3",
        "--Homepage-Color-Button": "#dce6f2",
        "--Homepage-FontColor-Button": "#2662ae",
        "--Homepage-Background-Button-Cancel": "#e0e0e0",
        "--Homepage-Color-Button-Cancel": "black",
        "--Homepage-Background-Button-Confirm": "#2662ae",
        "--Homepage-Color-Button-Confirm": "white",
      },
      data_user: {},
      list_menu: [{
          text: this.$t('AnswerQuestion.addFriend'),
          icon: 'mdi-account-search',
          path: '/addfriend'
        },
        {
          text: this.$t('AnswerQuestion.createGroup'),
          icon: 'mdi-account-multiple-plus',
          path: '/creategroup'
        }
      ],
      listfriend_send_invite: [],
      listfriend_invite: [],
      listgroup_invite: [],
      listfriend: [],
      listgroup: [],
      login_page: '',
      access_token_one: '',
      ListBusinessData: {},
      ListBusinessDialog: false,
      persistent: false,
    }
  },
  components: {
    DetailFriendDialog,
    DetailGroupDialog,
    ErrorDialog,
    WarningDialog,
    MenuLayout,
    ListBusiness,
  },
  computed: {
    FilterListfriend () {
      if (this.searchFriend !== '' && this.searchFriend !== null) {
        return this.listfriend.filter(post => {
          return post.name.toLowerCase().includes(this.searchFriend.toLowerCase())
        })
      } else {
        return this.listfriend
      }
    },
    FilterListgroup () {
      if (this.searchGroup !== '' && this.searchGroup !== null) {
        return this.listgroup.filter(post => {
          return post.name.toLowerCase().includes(this.searchGroup.toLowerCase())
        })
      } else {
        return this.listgroup
      }
    },
    ...sync('*')
  },
  watch: {
    search () {
      // console.log(this.search)
      if (this.search === null && this.search === '') {
        this.showTextField = true
        this.hideTextField = false
      }
    },
    socketfriend (data) {
      this.getListPending(this.data_user.tokenuser)
    },
    socketaccept_friend (data) {
      this.getListPending(this.data_user.tokenuser)
      this.getListFriend(this.data_user.tokenuser)
    },
    socketremove_request_friend (data) {
      this.getListPending(data.tokenuser)
    },
    socketremove_friend (data) {
      this.getListFriend(this.data_user.tokenuser)
    },
    socketcreate_group (data) {
      // console.log(data)
      this.getListPending(this.data_user.tokenuser)
    },
    socketinvite_group (data) {
      // console.log(data)
      this.getListPending(this.data_user.tokenuser)
    },
    socketactive_group (data) {
      // console.log(data)
      this.getListPending(data.tokenuser)
      this.getListGroup(data.tokenuser)
    },
    socketcencel_group (data) {
      // console.log(data)
      this.getListPending(data.tokenuser)
    },
    socketleave_group (data) {
      // console.log(data)
      this.getListGroup(data.tokenuser)
    },
    socket_kickmember (data) {
      // console.log(data)
      this.getListGroup(data.tokenuser)
    },
    socketmessage (data) {
      // console.log(data)
      this.count_read = this.count_read + 1
      // this.getnotcountread()
    },
  },
  created() {
    // console.log('homepage theme', this.themechat)
    // console.log(JSON.parse(this.$cookie.get('user-profile')))
    var user_profile = ''
    if (JSON.parse(this.$cookie.get('user-profile') == null)) {
      user_profile = JSON.parse(localStorage.getItem('user-profile'))
    } else {
      user_profile = JSON.parse(this.$cookie.get('user-profile'))
    }
    this.data_user = user_profile['account']['profile']
    this.login_page = this.$cookie.get('login-page')
    this.access_token_one = this.$cookie.get('one_token')
    this.getListFriend(this.data_user.tokenuser)
    this.getListGroup(this.data_user.tokenuser)
    this.getListPending(this.data_user.tokenuser)
  },
  methods: {
    switchAccount () {
      console.log('switchAccount');
      var header = { headers: { Authorization: `Bearer ${this.access_token_one}`} }
      this.ListBusinessData = header
      this.ListBusinessDialog = true
    },
    acceptGroup (item, index) {
      this.axios.post(process.env.VUE_APP_API_GO + `/v1/accept-group`, {
        group_id: item.group_id,
        tokenuser: this.data_user.tokenuser
      }).then((response) => {
        if (response.data.status === 'success') {
          this.listgroup_invite.splice(index, 1)
          this.getListGroup(this.data_user.tokenuser)
        } else {
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        }
      }).catch(err => {
        console.log(err)
        this.ErrorDialogDetail = {
          title: 'Error',
          text: this.$t('Alert.Fail.default.somethingWrong')
        }
        this.ErrorDialog = true
      })
    },
    emitWarning (item) {
      // console.log(item)
      this.WarningDialog = false
      this.axios.post(process.env.VUE_APP_API_MANAGE + `/cancelinvitegroup`, {
        tokenuser: this.data_user.tokenuser,
        group_id: item.detail.group_id,
      }).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          this.listgroup_invite.splice(index, 1)
          this.getListPending(this.data_user.tokenuser)
        } else {
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        }
      }).catch(err => {
        console.log(err)
        this.ErrorDialogDetail = {
          title: 'Error',
          text: this.$t('Alert.Fail.default.somethingWrong')
        }
        this.ErrorDialog = true
      })
    },
    closeAlertDialog (data) {
      // console.log(data)
      if (data.type === 'warning') {
        this.WarningDialog = data.value
      } else if (data.type === 'err') {
        this.ErrorDialog = data.value
      }
    },
    cancelGroup (item, index) {
      this.WarningDialogDetail = {
        title: this.$t('Alert.Sure'),
        text: this.$t('Alert.Group.cancelGroup', { name: item.name }),
        detail: item,
        index: index
      }
      this.WarningDialog = true
    },
    lengthactive (member, key) {
      var num = 0
      for (var i = 0; i < member.length; i += 1) {
        if (member[i][key] === 'active') {
          num = num + 1
        }
      }
      return num
    },
    acceptRequest (item, index) {
      this.axios.post(process.env.VUE_APP_API_GO + `/v1/accept-friend`, {
        tokenfriend: item.tokenuser,
        tokenuser: this.data_user.tokenuser
      }).then((response) => {
        if (response.data.status === 'success') {
          this.list_request_friend.splice(index, 1)
          this.getListFriend(this.data_user.tokenuser)
        } else {
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        }
      }).catch(err => {
        console.log(err)
        this.ErrorDialogDetail = {
          title: 'Error',
          text: this.$t('Alert.Fail.default.somethingWrong')
        }
        this.ErrorDialog = true
      })
    },
    cancelSendInvite (item, index, text) {
      this.axios.post(process.env.VUE_APP_API_MANAGE + `/removerequestfriend`, {
        tokenfriend: item.tokenuser,
        tokenuser: this.data_user.tokenuser
      }).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          // this.loading = false
          if (text === 'request') {
            this.listfriend_invite.splice(index, 1)
          } else if (text === 'send_request') {
            this.listfriend_send_invite.splice(index, 1)
          }
          this.getListPending(this.data_user.tokenuser)
        } else {
          // this.loading = false
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        }
      }).catch(err => {
        console.log(err)
        // this.loading = false
        this.ErrorDialogDetail = {
          title: 'Error',
          text: this.$t('Alert.Fail.default.somethingWrong')
        }
        this.ErrorDialog = true
      })
    },
    getListFriend (token) {
      this.axios.post(process.env.VUE_APP_API_GO + `/v1/get-list-friend`, {
        tokenuser: token
      }).then((response) => {
        if (response.data.status === 'success') {
          this.listfriend = response.data['list_friend']
          // this.listfriend = []
        }
      }).catch(err => {
        console.log(err)
        this.listfriend = []
      })
    },
    getListGroup (token) {
      this.axios.post(process.env.VUE_APP_API_GO + `/v1/get-list-group`, {
        tokenuser: token
      }).then((response) => {
        if (response.data.status === 'success') {
          this.listgroup = response.data['list_active_group']
        }
      }).catch(err => {
        console.log(err)
        this.listgroup = []
      })
    },
    getListPending (token) {
      this.axios.post(process.env.VUE_APP_API_GO + `/v1/get-list-pending`, {
        tokenuser: token
      }).then((response) => {
        if (response.data.status === 'success') {
          this.listfriend_send_invite = response.data['list_send_request_friend']
          this.listfriend_invite = response.data['list_request_friend']
          this.listgroup_invite = response.data['list_pending_group']

          this.count_request = response.data['list_request_friend'].length + response.data['list_pending_group'].length + response.data['list_send_request_friend'].length
        }
      }).catch(err => {
        console.log(err)
        this.listfriend_send_invite = []
        this.listfriend_invite = []
        this.listgroup_invite = []
        this.count_request = 0
      })
    },
    checkList () {
      if (this.listfriend_invite.length === 0 &&
          this.listfriend_send_invite.length === 0 &&
          this.listfriend.length === 0 &&
          this.listgroup.length === 0 &&
          this.listgroup_invite === 0)
      {
        return true
      } else {
        return false
      }
    },
    openDialog(text, item) {
      if (text === 'friend') {
        this.InforFriend = {
          email: item.email,
          name: item.name,
          phone: item.phone,
          profilepicture: item.profilepicture,
          status: item.status,
          tokenuser: item.tokenuser,
          type: item.type,
          tokenroom: item.tokenroom,
          statemember: 'friend'
        }
        this.DetailFriendDialog = true
      } else if (text === 'group') {
        this.InforGroup = item
        this.DetailGroupDialog = true
      } else if (text === 'send_sequest_friend') {
        this.InforFriend = {
          email: item.email,
          name: item.name,
          phone: item.phone,
          profilepicture: item.profilepicture,
          status: item.status,
          tokenuser: item.tokenuser,
          type: item.type,
          statemember: 'sendrequest'
        }
        this.DetailFriendDialog = true
      } else if (text === 'request') {
        this.InforFriend = {
          email: item.email,
          name: item.name,
          phone: item.phone,
          profilepicture: item.profilepicture,
          status: item.status,
          tokenuser: item.tokenuser,
          type: item.type,
          statemember: 'request'
        }
        this.DetailFriendDialog = true
      }
    },
    closeDialog(data) {
      if (data.name === 'DetailFriend') {
        this.DetailFriendDialog = data.value
      } else if (data.name === 'DetailGroup') {
        this.DetailGroupDialog = data.value
      } else if (data.name === 'ListBusiness') {
        this.ListBusinessData = {}
        this.ListBusinessDialog = data.value
      }
    },
    scrollFunctionGroup () {
      var scroll = this.$el.querySelector('#myscrollGroup')
      // console.log('scroll.scrollTop', scroll.scrollTop)
      // console.log('scroll.scrollHeight', scroll.scrollHeight)
      if (scroll.scrollTop !== 0) {
        // this.showTextField = false
        // this.hideTextField = true
        this.hideTextField = true
        this.showTitle = true
      } else {
        // this.showTextField = true
        // this.hideTextField = false
        this.hideTextField = false
        this.showTitle = false
      }
    },
    scrollFunction() {
      var scroll = this.$el.querySelector('#myscroll')
      // console.log('scroll.scrollTop', scroll.scrollTop)
      // console.log('scroll.scrollHeight', scroll.scrollHeight)
      if (scroll.scrollTop !== 0) {
        // this.showTextField = false
        // this.hideTextField = true
        this.hideTextField = true
        this.showTitle = true
      } else {
        // this.showTextField = true
        // this.hideTextField = false
        this.hideTextField = false
        this.showTitle = false
      }
    },
    routePage(path) {
      if (path === '/login') {
        this.$cookie.delete('login-page')
        this.$cookie.delete('one_token')
        path = `${process.env.VUE_APP_URL_PRIVATE}/login`
        window.open(path, '_self')
      } else {
        this.$router.push(path)
      }
    },
    ClearSearch () {
      this.search = null
      this.showTextField = true
      this.hideTextField = false
    },
    InputFocusCancel() {
      // this.search = null
      this.showTextField = true
      this.showTitle = false
    },
    InputFocus(ev) {
      // console.log(ev)
      if (ev) {
        this.showTextField = false
      } else {
        this.showTextField = true
      }
    }
  }
}
</script>

<style lang="css" scoped>
>>>.ant-tabs-nav .ant-tabs-tab-active {
  color: var(--Homepage-IconActive) !important;
  text-shadow: 0 0 0.25px currentColor !important;
}
>>>.ant-tabs-ink-bar {
  position: absolute;
  bottom: 1px;
  left: 0;
  z-index: 1;
  box-sizing: border-box;
  height: 2px;
  background-color: var(--Homepage-IconActive) !important;
  transform-origin: 0 0;
}
.layout-panels-group {
  height: calc(100vh - 260px) !important;
  /* height: 210px; */
  overflow-y: auto;
  /* background-color: bisque; */
  width: 100% !important;
}
.layout-panels-group::-webkit-scrollbar {
  width: 3px;
}

.layout-panels-group::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, .1);
}
  .text-overflow-header {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    width: 50vw;
  }
  .tab-title-header {
      color: var(--Homepage-FontColor) !important;
      font-size: var(--Homepage-FontSize-TitleHeader) !important;
      font-weight: 600;
    }
  .btn-confirm {
    background-color: var(--Homepage-Background-Button-Confirm) !important;
    color: var(--Homepage-Color-Button-Confirm) !important;
    text-transform: none !important;
    border-radius: 10px !important;
  }
  .btn-cancel {
    background-color: var(--Homepage-Background-Button-Cancel) !important;
    color: var(--Homepage-Color-Button-Cancel) !important;
    text-transform: none !important;
    border-radius: 10px !important;
  }
  .icon-color {
    color: var(--Homepage-FontColor-Status) !important;
    font-size: 16px !important;
  }
  .img-position {
    object-fit: cover;
    object-position: 50% 0;
    border-style: solid;
    border-width: thin;
    border-color: #e8e8e8;
  }
  .layout-panels {
    height: calc(100vh - 220px) !important;
    overflow-y: auto;
    /* background-color: bisque; */
    width: 100% !important;
  }
  .layout-panels::-webkit-scrollbar {
    width: 3px;
  }

  .layout-panels::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: rgba(0, 0, 0, .1);
  }
  >>>.v-expansion-panel-content__wrap {
    padding: 0px !important;
  }
  >>>.theme--light.v-expansion-panels .v-expansion-panel-header .v-expansion-panel-header__icon .v-icon {
      color: rgba(0,0,0,.54);
      /* display: none !important; */
  }
  >>>.v-expansion-panel:before {
    box-shadow: none !important;
  }
  >>>.v-expansion-panels:not(.v-expansion-panels--accordion):not(.v-expansion-panels--tile)>.v-expansion-panel--active {
    border-radius: 4px !important;
    /* border-top-color: #f3f3f3 !important;
    border-top-style: solid !important;
    border-top-width: thin !important; */
  }
  >>>.v-application--is-ltr .v-list-group--no-action > .v-list-group__items > .v-list-item {
    padding-left: 0px !important;
  }
  .card-list {
    width: 100% !important;
    box-shadow: none !important;
  }
  .font-color-btn {
    color: var(--Homepage-FontColor-Button) !important;
  }
  .fz-28 {
    font-size: 28px !important;
  }
  .color-btn {
    /* background-color: var(--Homepage-Color-Button) !important; */
    color: var(--Homepage-IconActive) !important;
    text-transform: none !important;
  }
  .layout-page {
    height: calc(100vh - 64px) !important;
    overflow: hidden !important;
    background-color: var(--Homepage-Background) !important;
  }
  .tab-title {
    color: var(--Homepage-FontColor) !important;
    font-size: var(--Homepage-FontSize) !important;
    font-weight: 600;
  }
  .tab-title-status {
    color: var(--Homepage-FontColor-Status) !important;
    font-size: var(--Homepage-FontSize-Status) !important;
  }
  .text-overflow {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    width: 70vw;
  }
  >>>.v-input__slot {
    background-color: var(--Homepage-Background-Input) !important;
    border-radius: 10px !important;
  }
  >>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
    box-shadow: none !important;
  }
  >>>.v-btn--is-elevated.v-btn--fab {
    box-shadow: none;
  }
</style>
